import { useQuery } from '@tanstack/react-query';
import { useAuthStore } from '../store/auth.store';
import { fetchNdviSettings } from '../api/ndvi-settings.api';

/**
 * Valor efectivo del ajuste `ndvi.enabled` (apagado por defecto; empresa y
 * rancho). `known` = ya se resolvió (si la lectura falla queda en false y la
 * pantalla se apoya en el 403 `ndvi_disabled` del backend, que sigue siendo
 * la guardia real). Sin reintentos: el 403/error no debe reintentarse en bucle.
 */
export function useNdviSettings() {
  const tenantId = useAuthStore(s => s.user?.tenantId);
  const { data, isLoading } = useQuery({
    queryKey: ['ndvi-settings', tenantId],
    queryFn: fetchNdviSettings,
    enabled: !!tenantId,
    retry: false,
    staleTime: 5 * 60 * 1000,
  });

  return {
    isLoading,
    known: !!data,
    /** true / false si se conoce el valor; undefined si no se pudo leer. */
    isEnabledForRancho: (ranchoId?: string | null): boolean | undefined => {
      if (!data) return undefined;
      return ranchoId && ranchoId in data.ranchos ? data.ranchos[ranchoId] : data.tenantEnabled;
    },
    /** Hay al menos un rancho (o la empresa) con NDVI habilitado. undefined si se desconoce. */
    anyEnabled: data ? data.tenantEnabled || Object.values(data.ranchos).some(Boolean) : undefined,
  };
}
